/**
 * Client-side CSV download for chart data.
 * Exports contain ONLY the values shown in the chart — no sample sizes,
 * margins of error, or other metadata (per product requirement).
 */
export function downloadCsv(filename, headers, rows) {
  const esc = (v) => {
    const s = v == null ? '' : String(v);
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const lines = [
    headers.map(esc).join(','),
    ...rows.map((r) => r.map(esc).join(','))
  ];
  // BOM so Excel opens UTF-8 correctly
  const blob = new Blob(['\uFEFF' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = sanitizeFilename(filename) + '.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function sanitizeFilename(name) {
  return String(name || 'chart_data')
    .replace(/[^\w\s.-]+/g, '')
    .trim()
    .replace(/\s+/g, '_')
    .slice(0, 120) || 'chart_data';
}
